import { GriffelStyle, makeStyles, tokens } from "@fluentui/react-components";

const btn: GriffelStyle = {
    ':focus': {
        outline: 'none',
        boxShadow: 'none',
    },
    ':focus-visible': {
        outline: 'none',
        boxShadow: 'none',
    },
};

export const useButtonStyles = makeStyles({
    root: {
        ...btn,
    },
    linkButton: {
        ...btn,
        fontSize: '13px',
    },
    buttonOnDark: {
        color: tokens.colorNeutralForegroundStaticInverted,
    },
    childrenButtons: {
        '& button': {
            ...btn,
        },
    },
    // Mirrors appearance='primary' but with the status success palette.
    successButton: {
        ...btn,
        backgroundColor: tokens.colorStatusSuccessBackground3,
        color: tokens.colorNeutralForegroundOnBrand,
        border: 'none',
        // Fluent has no hover/pressed variants for the success background, so shade it manually.
        ':hover': {
            backgroundColor: tokens.colorStatusSuccessBackground3,
            color: tokens.colorNeutralForegroundOnBrand,
            filter: 'brightness(0.92)',
        },
        ':hover:active': {
            backgroundColor: tokens.colorStatusSuccessBackground3,
            color: tokens.colorNeutralForegroundOnBrand,
            filter: 'brightness(0.85)',
        },
        ':disabled': {
            backgroundColor: tokens.colorNeutralBackgroundDisabled,
            color: tokens.colorNeutralForegroundDisabled,
            border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStrokeDisabled}`,
        },
        ':disabled:hover': {
            backgroundColor: tokens.colorNeutralBackgroundDisabled,
            color: tokens.colorNeutralForegroundDisabled,
        },
    },
    // Mirrors appearance='primary' but with the status danger palette.
    dangerButton: {
        ...btn,
        backgroundColor: tokens.colorStatusDangerBackground3,
        color: tokens.colorNeutralForegroundOnBrand,
        border: 'none',
        ':hover': {
            backgroundColor: tokens.colorStatusDangerBackground3Hover,
            color: tokens.colorNeutralForegroundOnBrand,
        },
        ':hover:active': {
            backgroundColor: tokens.colorStatusDangerBackground3Pressed,
            color: tokens.colorNeutralForegroundOnBrand,
        },
        ':disabled': {
            backgroundColor: tokens.colorNeutralBackgroundDisabled,
            color: tokens.colorNeutralForegroundDisabled,
            border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStrokeDisabled}`,
        },
        ':disabled:hover': {
            backgroundColor: tokens.colorNeutralBackgroundDisabled,
            color: tokens.colorNeutralForegroundDisabled,
        },
    },
});